import React from 'react';
import { Alert, Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from "react-router-dom";
import PublicNavigation from '../components/Navigation/PublicNavigation';

const plans = [
    {
        name: 'Arranque',
        units: '1 - 5 unidades',
        price: '$1,990',
        detail: 'MXN / mes*',
        features: [
            'Bases de datos ilimitadas',
            'Módulo operaciones: clientes, rutas, viajes y mantenimientos de unidades',
            'Módulo finanzas: facturación y carta porte con un click',
            'Manuales de usuario',
            'Mejoras y actualizaciones constantes'
        ]
    },
    {
        name: 'Crecimiento',
        units: '6 - 25 unidades',
        price: '$5,490',
        detail: 'MXN / mes*',
        featured: true,
        features: [
            'Todo Arranque',
            'Módulo RH para cálculo automático de nómina y comisiones',
            'Módulo rendimientos diésel por unidad',
            'Agente IA para cobranza automática',
            'Dashboard ejecutivo',
            'Soporte 24/7/365'
        ]
    },
    {
        name: 'Flota',
        units: '26+ unidades',
        price: 'Personalizado',
        detail: 'desde $12,000 MXN / mes*',
        features: [
            'Todo Crecimiento',
            'Módulo monitoreo: visualización de GPS',
            'Agente IA para reportes ejecutivos',
            'Agente IA para servicio al cliente: cotizar y agendar viajes',
            'Acceso anticipado a nuevas funcionalidades'
        ]
    }
];

const pageStyles = {
    page: {
        backgroundColor: '#f7f9fa',
        minHeight: '100vh',
        color: '#16232b'
    },
    hero: {
        paddingTop: '150px',
        paddingBottom: '52px'
    },
    freeAlert: {
        backgroundColor: '#e8f4ee',
        borderColor: '#bfddcf',
        color: '#154b35'
    },
    card: {
        border: '1px solid #dfe5e8',
        borderRadius: '0',
        backgroundColor: '#ffffff',
        borderTop: '12px solid #00465a',
        minHeight: '100%',
        padding: '42px 40px'
    },
    featuredCard: {
        backgroundColor: '#00465a',
        borderColor: '#00465a',
        borderTopColor: '#ffb22e',
        color: '#ffffff'
    },
    planName: {
        fontSize: '28px',
        fontWeight: 800,
        letterSpacing: '0',
        textTransform: 'uppercase'
    },
    units: {
        color: '#9eabb2',
        fontSize: '24px',
        marginTop: '22px'
    },
    price: {
        color: '#16232b',
        fontSize: '58px',
        fontWeight: 800,
        marginTop: '24px',
        marginBottom: '6px',
        lineHeight: 1
    },
    divider: {
        borderTop: '2px solid #dfe5e8',
        margin: '26px 0 22px'
    },
    feature: {
        color: '#65747c',
        fontSize: '16px',
        lineHeight: 1.35,
        marginBottom: '12px'
    }
};

const PricingCard = ({ plan }) => {
    const cardStyle = plan.featured
        ? { ...pageStyles.card, ...pageStyles.featuredCard }
        : pageStyles.card;
    const mutedColor = plan.featured ? '#bfd1d8' : '#9eabb2';
    const mainTextColor = plan.featured ? '#ffffff' : '#16232b';
    const planNameColor = plan.featured ? '#ffb22e' : '#00465a';

    return (
        <div style={cardStyle}>
            <h2 style={{ ...pageStyles.planName, color: planNameColor }}>{plan.name}</h2>
            <p style={{ ...pageStyles.units, color: mutedColor }}>{plan.units}</p>
            <div style={{ ...pageStyles.price, color: mainTextColor }}>{plan.price}</div>
            <p style={{ color: mutedColor, fontSize: '20px', marginBottom: 0 }}>{plan.detail}</p>
            <div style={{ ...pageStyles.divider, borderTopColor: plan.featured ? '#477280' : '#dfe5e8' }} />
            <ul className="list-unstyled mb-4">
                {plan.features.map((feature) => (
                    <li key={feature} style={{ ...pageStyles.feature, color: plan.featured ? '#c4d4da' : '#65747c' }}>
                        <span aria-hidden="true" style={{ color: plan.featured ? '#ffffff' : '#00465a', marginRight: '10px' }}>✓</span>
                        {feature}
                    </li>
                ))}
            </ul>
            <Button
                as={Link}
                to="/signup"
                variant={plan.featured ? 'light' : 'primary'}
                className="w-100"
                style={plan.featured ? { color: '#00465a', fontWeight: 700 } : { fontWeight: 700 }}
            >
                Registrarse
            </Button>
        </div>
    );
};

const Pricing = () => (
    <div style={pageStyles.page}>
        <PublicNavigation />

        <main style={pageStyles.hero}>
            <Container fluid className="px-4 px-lg-5">
                <Row className="justify-content-center mb-5">
                    <Col md={8} lg={5}>
                        <Alert style={pageStyles.freeAlert} className="text-center px-4 py-3 mb-0">
                            <h2 className="h4 mb-2">Primeros 6 meses GRATIS</h2>
                            <p className="mb-0">Activa tu empresa sin costo inicial en el plan que corresponda a tu flotilla.</p>
                        </Alert>
                    </Col>
                </Row>

                <Row className="g-4 align-items-stretch">
                    {plans.map((plan) => (
                        <Col lg={4} key={plan.name}>
                            <PricingCard plan={plan} />
                        </Col>
                    ))}
                </Row>

                <p className="mt-4 mb-0" style={{ color: '#b4bfc5', fontSize: '15px' }}>
                    *Nota: Los timbres SAT no están incluidos.
                </p>
            </Container>
        </main>
    </div>
);

export default Pricing;
